import type { ApiConfig } from '../../types'

export const spotTradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'desc',
  range: (30 * 24 * 60 * 60 - 1) * 1000, // 30 days in milliseconds
  requiresRange: true,
  type: 'spot-trade-history',
} as const satisfies ApiConfig
